import React from 'react';
import styled from "styled-components";

export var Home = styled.main.withConfig({
  componentId: "s9u2i28-0"
})(["align-items:center;display:flex;flex-direction:column;flex:1;justify-content:space-between;padding:25px;text-align:center;"]);
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Home/style.js
// module id = 294
// module chunks = 0